import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { store } from '@/store';
//  获取字典方法 使用示例 getDict('sex').then(res)  或者 async函数下 const res = await getDict('sex')
export var getDict = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(type) {
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return store.dispatch('dictionary/getDictionary', type);
        case 1:
          return _context.abrupt("return", store.getters['dictionary/getDictionary'][type]);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getDict(_x) {
    return _ref.apply(this, arguments);
  };
}();